// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json = require("../Json.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var GraphqlHelpers = require("../GraphqlHelpers.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_Invoice_Shift = require("./CommonTypes_Invoice_Shift.bs.js");
var CommonTypes_Invoice_Business = require("./CommonTypes_Invoice_Business.bs.js");

var include = TypeUtils.MakeOpaqueIntType({});

var fromInt = include.fromInt;

var toInt = include.toInt;

var compare = include.compare;

var eq = include.eq;

function parse(param) {
  return Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: toInt
};

var Id_fromString = include.fromString;

var Id_toString = include.toString;

var Id_decode = include.decode;

var Id_encode = include.encode;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromInt: fromInt,
  fromString: Id_fromString,
  toInt: toInt,
  toString: Id_toString,
  decode: Id_decode,
  encode: Id_encode,
  compare: compare,
  eq: eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  GraphQL_API: GraphQL_API
};

var include$1 = TypeUtils.MakeOpaqueStringType({});

var decode = include$1.decode;

var encode = include$1.encode;

function parse$1(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API$1 = {
  parse: parse$1,
  serialize: encode
};

var InvoiceNumber_fromString = include$1.fromString;

var InvoiceNumber_toString = include$1.toString;

var InvoiceNumber_compare = include$1.compare;

var InvoiceNumber_eq = include$1.eq;

var InvoiceNumber_Ord = include$1.Ord;

var InvoiceNumber_Set = include$1.$$Set;

var InvoiceNumber_Map = include$1.$$Map;

var InvoiceNumber = {
  fromString: InvoiceNumber_fromString,
  toString: InvoiceNumber_toString,
  decode: decode,
  encode: encode,
  compare: InvoiceNumber_compare,
  eq: InvoiceNumber_eq,
  Ord: InvoiceNumber_Ord,
  $$Set: InvoiceNumber_Set,
  $$Map: InvoiceNumber_Map,
  GraphQL_API: GraphQL_API$1
};

var include$2 = TypeUtils.MakeOpaqueIntType({});

var fromInt$1 = include$2.fromInt;

var toInt$1 = include$2.toInt;

function parse$2(param) {
  return Relude_Globals.$great$great(fromInt$1, Relude_Option.getOrThrow, param);
}

var GraphQL_API$2 = {
  parse: parse$2,
  serialize: toInt$1
};

var ExternalInvoiceId_fromString = include$2.fromString;

var ExternalInvoiceId_toString = include$2.toString;

var ExternalInvoiceId_decode = include$2.decode;

var ExternalInvoiceId_encode = include$2.encode;

var ExternalInvoiceId_compare = include$2.compare;

var ExternalInvoiceId_eq = include$2.eq;

var ExternalInvoiceId_Ord = include$2.Ord;

var ExternalInvoiceId_Set = include$2.$$Set;

var ExternalInvoiceId_Map = include$2.$$Map;

var ExternalInvoiceId = {
  fromInt: fromInt$1,
  fromString: ExternalInvoiceId_fromString,
  toInt: toInt$1,
  toString: ExternalInvoiceId_toString,
  decode: ExternalInvoiceId_decode,
  encode: ExternalInvoiceId_encode,
  compare: ExternalInvoiceId_compare,
  eq: ExternalInvoiceId_eq,
  Ord: ExternalInvoiceId_Ord,
  $$Set: ExternalInvoiceId_Set,
  $$Map: ExternalInvoiceId_Map,
  GraphQL_API: GraphQL_API$2
};

var include$3 = TypeUtils.MakeOpaqueIntType({});

var fromInt$2 = include$3.fromInt;

var toInt$2 = include$3.toInt;

function parse$3(param) {
  return Relude_Globals.$great$great(fromInt$2, Relude_Option.getOrThrow, param);
}

var GraphQL_API$3 = {
  parse: parse$3,
  serialize: toInt$2
};

var ExternalInvoiceAmountCents_fromString = include$3.fromString;

var ExternalInvoiceAmountCents_toString = include$3.toString;

var ExternalInvoiceAmountCents_decode = include$3.decode;

var ExternalInvoiceAmountCents_encode = include$3.encode;

var ExternalInvoiceAmountCents_compare = include$3.compare;

var ExternalInvoiceAmountCents_eq = include$3.eq;

var ExternalInvoiceAmountCents_Ord = include$3.Ord;

var ExternalInvoiceAmountCents_Set = include$3.$$Set;

var ExternalInvoiceAmountCents_Map = include$3.$$Map;

var ExternalInvoiceAmountCents = {
  fromInt: fromInt$2,
  fromString: ExternalInvoiceAmountCents_fromString,
  toInt: toInt$2,
  toString: ExternalInvoiceAmountCents_toString,
  decode: ExternalInvoiceAmountCents_decode,
  encode: ExternalInvoiceAmountCents_encode,
  compare: ExternalInvoiceAmountCents_compare,
  eq: ExternalInvoiceAmountCents_eq,
  Ord: ExternalInvoiceAmountCents_Ord,
  $$Set: ExternalInvoiceAmountCents_Set,
  $$Map: ExternalInvoiceAmountCents_Map,
  GraphQL_API: GraphQL_API$3
};

function toEnum(param) {
  switch (param) {
    case 0 :
        return /* Standard */0;
    case 1 :
        return /* ByLocationAndDay */1;
    case 2 :
        return /* IndividualInvoicesByLocationAndDay */2;
    default:
      return ;
  }
}

function fromEnum(param) {
  if (typeof param === "number") {
    return param;
  } else {
    return 2;
  }
}

var include$4 = TypeUtils.TypeClasses.WithGenerateable({
      startingIndex: 0,
      fromEnum: fromEnum,
      toEnum: toEnum
    });

function toString(x) {
  if (typeof x !== "number") {
    return x._0;
  }
  switch (x) {
    case /* Standard */0 :
        return "standard";
    case /* ByLocationAndDay */1 :
        return "by_location_and_day";
    case /* IndividualInvoicesByLocationAndDay */2 :
        return "individual_invoices_by_location_and_day";
    
  }
}

function toDisplayString(x) {
  if (typeof x !== "number") {
    return x._0;
  }
  switch (x) {
    case /* Standard */0 :
        return "Standard";
    case /* ByLocationAndDay */1 :
        return "By Location and Day";
    case /* IndividualInvoicesByLocationAndDay */2 :
        return "Individual Invoices by Location and Day";
    
  }
}

function fromString(x) {
  switch (x) {
    case "by_location_and_day" :
        return /* ByLocationAndDay */1;
    case "individual_invoices_by_location_and_day" :
        return /* IndividualInvoicesByLocationAndDay */2;
    case "standard" :
        return /* Standard */0;
    default:
      return /* FutureAddedValue */{
              _0: x
            };
  }
}

var decode$1 = Curry._1(Json.Decode.variantFromString, (function (param) {
        return Relude_Globals.$great$great(fromString, Relude_Option.pure, param);
      }));

function parseApiResponse(param) {
  if (typeof param === "string") {
    if (param === "BY_LOCATION_AND_DAY") {
      return /* ByLocationAndDay */1;
    } else if (param === "INDIVIDUAL_INVOICES_BY_LOCATION_AND_DAY") {
      return /* IndividualInvoicesByLocationAndDay */2;
    } else {
      return /* Standard */0;
    }
  } else {
    return /* FutureAddedValue */{
            _0: param.VAL
          };
  }
}

function encode$1(param) {
  return Relude_Globals.$great$great((function (string) {
                if (typeof string !== "number") {
                  return string._0;
                }
                switch (string) {
                  case /* Standard */0 :
                      return "STANDARD";
                  case /* ByLocationAndDay */1 :
                      return "BY_LOCATION_AND_DAY";
                  case /* IndividualInvoicesByLocationAndDay */2 :
                      return "INDIVIDUAL_INVOICES_BY_LOCATION_AND_DAY";
                  
                }
              }), (function (prim) {
                return prim;
              }), param);
}

var Style_fromEnum = include$4.fromEnum;

var Style_toEnum = include$4.toEnum;

var Style_eq = include$4.eq;

var Style_compare = include$4.compare;

var Style_Ord = include$4.Ord;

var Style_compareWithConversion = include$4.compareWithConversion;

var Style_compareReversed = include$4.compareReversed;

var Style_OrdReversed = include$4.OrdReversed;

var Style_compareAsInt = include$4.compareAsInt;

var Style_min = include$4.min;

var Style_max = include$4.max;

var Style_lessThan = include$4.lessThan;

var Style_lt = include$4.lt;

var Style_lessThanOrEq = include$4.lessThanOrEq;

var Style_lte = include$4.lte;

var Style_greaterThan = include$4.greaterThan;

var Style_gt = include$4.gt;

var Style_greaterThanOrEq = include$4.greaterThanOrEq;

var Style_gte = include$4.gte;

var Style_clamp = include$4.clamp;

var Style_between = include$4.between;

var Style_OrdRingExtensions = include$4.OrdRingExtensions;

var Style_OrdNamed = include$4.OrdNamed;

var Style_OrdBy = include$4.OrdBy;

var Style_Set = include$4.$$Set;

var Style_SetWithNone = include$4.SetWithNone;

var Style_Map = include$4.$$Map;

var Style_list = include$4.list;

var Style_array = include$4.array;

var Style_set = include$4.set;

var Style_setWithNone = include$4.setWithNone;

var Style_cardinality = include$4.cardinality;

var Style_top = include$4.top;

var Style_bottom = include$4.bottom;

var Style_succ = include$4.succ;

var Style_pred = include$4.pred;

var Style = {
  fromEnum: Style_fromEnum,
  toEnum: Style_toEnum,
  eq: Style_eq,
  compare: Style_compare,
  Ord: Style_Ord,
  compareWithConversion: Style_compareWithConversion,
  compareReversed: Style_compareReversed,
  OrdReversed: Style_OrdReversed,
  compareAsInt: Style_compareAsInt,
  min: Style_min,
  max: Style_max,
  lessThan: Style_lessThan,
  lt: Style_lt,
  lessThanOrEq: Style_lessThanOrEq,
  lte: Style_lte,
  greaterThan: Style_greaterThan,
  gt: Style_gt,
  greaterThanOrEq: Style_greaterThanOrEq,
  gte: Style_gte,
  clamp: Style_clamp,
  between: Style_between,
  OrdRingExtensions: Style_OrdRingExtensions,
  OrdNamed: Style_OrdNamed,
  OrdBy: Style_OrdBy,
  $$Set: Style_Set,
  SetWithNone: Style_SetWithNone,
  $$Map: Style_Map,
  list: Style_list,
  array: Style_array,
  set: Style_set,
  setWithNone: Style_setWithNone,
  cardinality: Style_cardinality,
  top: Style_top,
  bottom: Style_bottom,
  succ: Style_succ,
  pred: Style_pred,
  toString: toString,
  toDisplayString: toDisplayString,
  fromString: fromString,
  decode: decode$1,
  parseApiResponse: parseApiResponse,
  encode: encode$1
};

function toDisplayString$1(param) {
  switch (param) {
    case /* New */0 :
        return "New";
    case /* Sent */1 :
        return "Sent";
    case /* Processing */2 :
        return "Processing";
    case /* Completed */3 :
        return "Completed";
    case /* Failed */4 :
        return "Failed";
    
  }
}

var PayableWithStripeStatus = {
  toDisplayString: toDisplayString$1
};

function toDisplayString$2(param) {
  switch (param) {
    case /* New */0 :
        return "New";
    case /* Sent */1 :
        return "Sent";
    case /* Completed */2 :
        return "Completed";
    
  }
}

var NonStripePaymentNeededStatus = {
  toDisplayString: toDisplayString$2
};

function fromString$1(param) {
  return Relude_Globals.$great$great(Relude_String.toLowerCase, (function (param) {
                switch (param) {
                  case "db error check row" :
                      return /* Unknown */0;
                  case "non stripe payment completed" :
                      return {
                              TAG: /* NonStripePaymentNeeded */1,
                              _0: /* Completed */2
                            };
                  case "non stripe payment new" :
                      return {
                              TAG: /* NonStripePaymentNeeded */1,
                              _0: /* New */0
                            };
                  case "non stripe payment sent" :
                      return {
                              TAG: /* NonStripePaymentNeeded */1,
                              _0: /* Sent */1
                            };
                  case "payable with stripe completed" :
                      return {
                              TAG: /* PayableWithStripe */0,
                              _0: /* Completed */3
                            };
                  case "payable with stripe failed" :
                      return {
                              TAG: /* PayableWithStripe */0,
                              _0: /* Failed */4
                            };
                  case "payable with stripe new" :
                      return {
                              TAG: /* PayableWithStripe */0,
                              _0: /* New */0
                            };
                  case "payable with stripe processing" :
                      return {
                              TAG: /* PayableWithStripe */0,
                              _0: /* Processing */2
                            };
                  case "payable with stripe sent" :
                      return {
                              TAG: /* PayableWithStripe */0,
                              _0: /* Sent */1
                            };
                  default:
                    return ;
                }
              }), param);
}

function toString$1(param) {
  if (typeof param === "number") {
    return "db error check row";
  }
  if (param.TAG === /* PayableWithStripe */0) {
    switch (param._0) {
      case /* New */0 :
          return "payable with stripe new";
      case /* Sent */1 :
          return "payable with stripe sent";
      case /* Processing */2 :
          return "payable with stripe processing";
      case /* Completed */3 :
          return "payable with stripe completed";
      case /* Failed */4 :
          return "payable with stripe failed";
      
    }
  } else {
    switch (param._0) {
      case /* New */0 :
          return "non stripe payment new";
      case /* Sent */1 :
          return "non stripe payment sent";
      case /* Completed */2 :
          return "non stripe payment completed";
      
    }
  }
}

function parseApiResponse$1(param) {
  if (typeof param === "string") {
    if (param === "PAYABLE_WITH_STRIPE_PROCESSING") {
      return {
              TAG: /* PayableWithStripe */0,
              _0: /* Processing */2
            };
    } else if (param === "PAYABLE_WITH_STRIPE_COMPLETED") {
      return {
              TAG: /* PayableWithStripe */0,
              _0: /* Completed */3
            };
    } else if (param === "PAYABLE_WITH_STRIPE_FAILED") {
      return {
              TAG: /* PayableWithStripe */0,
              _0: /* Failed */4
            };
    } else if (param === "PAYABLE_WITH_STRIPE_SENT") {
      return {
              TAG: /* PayableWithStripe */0,
              _0: /* Sent */1
            };
    } else if (param === "INVOICE_IS_IN_AN_UNKNOWN_STATUS") {
      return /* Unknown */0;
    } else if (param === "NON_STRIPE_PAYMENT_COMPLETED") {
      return {
              TAG: /* NonStripePaymentNeeded */1,
              _0: /* Completed */2
            };
    } else if (param === "NON_STRIPE_PAYMENT_NEW") {
      return {
              TAG: /* NonStripePaymentNeeded */1,
              _0: /* New */0
            };
    } else if (param === "PAYABLE_WITH_STRIPE_NEW") {
      return {
              TAG: /* PayableWithStripe */0,
              _0: /* New */0
            };
    } else {
      return {
              TAG: /* NonStripePaymentNeeded */1,
              _0: /* Sent */1
            };
    }
  } else {
    return /* Unknown */0;
  }
}

var decode$2 = Curry._1(Json.Decode.variantFromString, fromString$1);

function encode$2(param) {
  return Relude_Globals.$great$great(toString$1, (function (prim) {
                return prim;
              }), param);
}

var Status = {
  PayableWithStripeStatus: PayableWithStripeStatus,
  NonStripePaymentNeededStatus: NonStripePaymentNeededStatus,
  fromString: fromString$1,
  toString: toString$1,
  parseApiResponse: parseApiResponse$1,
  decode: decode$2,
  encode: encode$2
};

var Raw = {};

var query = "fragment CommonTypes_Invoice on Invoice   {\nbusiness  {\n...CommonTypes_Invoice_Business   \n}\n\nexternalInvoiceAmountCents  \nexternalInvoiceId  \nid  \ninvoiceDate  \ninvoiceNumber  \nshifts  {\nnodes  {\n...CommonTypes_Invoice_Shift   \n}\n\n}\n\nstatus  \n}\n" + CommonTypes_Invoice_Business.query + CommonTypes_Invoice_Shift.query;

function parse$4(value) {
  var value$1 = value.business;
  var value$2 = value.shifts;
  var value$3 = value$2.nodes;
  var value$4 = value.status;
  var tmp;
  if (value$4 == null) {
    tmp = undefined;
  } else {
    var tmp$1;
    switch (value$4) {
      case "INVOICE_IS_IN_AN_UNKNOWN_STATUS" :
          tmp$1 = "INVOICE_IS_IN_AN_UNKNOWN_STATUS";
          break;
      case "NON_STRIPE_PAYMENT_COMPLETED" :
          tmp$1 = "NON_STRIPE_PAYMENT_COMPLETED";
          break;
      case "NON_STRIPE_PAYMENT_NEW" :
          tmp$1 = "NON_STRIPE_PAYMENT_NEW";
          break;
      case "NON_STRIPE_PAYMENT_SENT" :
          tmp$1 = "NON_STRIPE_PAYMENT_SENT";
          break;
      case "PAYABLE_WITH_STRIPE_COMPLETED" :
          tmp$1 = "PAYABLE_WITH_STRIPE_COMPLETED";
          break;
      case "PAYABLE_WITH_STRIPE_FAILED" :
          tmp$1 = "PAYABLE_WITH_STRIPE_FAILED";
          break;
      case "PAYABLE_WITH_STRIPE_NEW" :
          tmp$1 = "PAYABLE_WITH_STRIPE_NEW";
          break;
      case "PAYABLE_WITH_STRIPE_PROCESSING" :
          tmp$1 = "PAYABLE_WITH_STRIPE_PROCESSING";
          break;
      case "PAYABLE_WITH_STRIPE_SENT" :
          tmp$1 = "PAYABLE_WITH_STRIPE_SENT";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$4
        };
    }
    tmp = tmp$1;
  }
  return {
          business: CommonTypes_Invoice_Business.verifyArgsAndParse("CommonTypes_Invoice_Business", value$1),
          externalInvoiceAmountCents: Relude_Globals.$great$great(fromInt$2, Relude_Option.getOrThrow, value.externalInvoiceAmountCents),
          externalInvoiceId: Relude_Globals.$great$great(fromInt$1, Relude_Option.getOrThrow, value.externalInvoiceId),
          id: Relude_Globals.$great$great(fromInt, Relude_Option.getOrThrow, value.id),
          invoiceDate: GraphqlHelpers.Datetime.parse(value.invoiceDate),
          invoiceNumber: parse$1(value.invoiceNumber),
          shifts: {
            nodes: value$3.map(function (value) {
                  if (!(value == null)) {
                    return CommonTypes_Invoice_Shift.verifyArgsAndParse("CommonTypes_Invoice_Shift", value);
                  }
                  
                })
          },
          status: tmp
        };
}

function serialize(value) {
  var value$1 = value.status;
  var status = value$1 !== undefined ? (
      typeof value$1 === "string" ? (
          value$1 === "PAYABLE_WITH_STRIPE_PROCESSING" ? "PAYABLE_WITH_STRIPE_PROCESSING" : (
              value$1 === "PAYABLE_WITH_STRIPE_COMPLETED" ? "PAYABLE_WITH_STRIPE_COMPLETED" : (
                  value$1 === "PAYABLE_WITH_STRIPE_FAILED" ? "PAYABLE_WITH_STRIPE_FAILED" : (
                      value$1 === "PAYABLE_WITH_STRIPE_SENT" ? "PAYABLE_WITH_STRIPE_SENT" : (
                          value$1 === "INVOICE_IS_IN_AN_UNKNOWN_STATUS" ? "INVOICE_IS_IN_AN_UNKNOWN_STATUS" : (
                              value$1 === "NON_STRIPE_PAYMENT_COMPLETED" ? "NON_STRIPE_PAYMENT_COMPLETED" : (
                                  value$1 === "NON_STRIPE_PAYMENT_NEW" ? "NON_STRIPE_PAYMENT_NEW" : (
                                      value$1 === "PAYABLE_WITH_STRIPE_NEW" ? "PAYABLE_WITH_STRIPE_NEW" : "NON_STRIPE_PAYMENT_SENT"
                                    )
                                )
                            )
                        )
                    )
                )
            )
        ) : value$1.VAL
    ) : null;
  var value$2 = value.shifts;
  var value$3 = value$2.nodes;
  var nodes = value$3.map(function (value) {
        if (value !== undefined) {
          return CommonTypes_Invoice_Shift.serialize(value);
        } else {
          return null;
        }
      });
  var shifts = {
    nodes: nodes
  };
  var value$4 = value.invoiceNumber;
  var value$5 = Curry._1(encode, value$4);
  var value$6 = value.invoiceDate;
  var value$7 = Curry._1(GraphqlHelpers.Datetime.serialize, value$6);
  var value$8 = value.id;
  var value$9 = Curry._1(toInt, value$8);
  var value$10 = value.externalInvoiceId;
  var value$11 = Curry._1(toInt$1, value$10);
  var value$12 = value.externalInvoiceAmountCents;
  var value$13 = Curry._1(toInt$2, value$12);
  var value$14 = value.business;
  var business = CommonTypes_Invoice_Business.serialize(value$14);
  return {
          business: business,
          externalInvoiceAmountCents: value$13,
          externalInvoiceId: value$11,
          id: value$9,
          invoiceDate: value$7,
          invoiceNumber: value$5,
          shifts: shifts,
          status: status
        };
}

function verifyArgsAndParse(_CommonTypes_Invoice, value) {
  return parse$4(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var status = param.status;
  var nodes = param.shifts.nodes;
  var invoiceNumber = param.invoiceNumber;
  var invoiceDate = param.invoiceDate;
  var id = param.id;
  var externalInvoiceId = param.externalInvoiceId;
  var externalInvoiceAmountCents = param.externalInvoiceAmountCents;
  if (status !== undefined) {
    return Relude_Option.map((function (business) {
                  return {
                          business: business,
                          externalInvoiceAmountCents: externalInvoiceAmountCents,
                          externalInvoiceId: externalInvoiceId,
                          id: id,
                          invoiceDate: invoiceDate,
                          invoiceNumber: invoiceNumber,
                          shifts: Relude_Array.mapOption((function (param) {
                                  return Relude_Option.map(CommonTypes_Invoice_Shift.tToR, param);
                                }), nodes),
                          status: parseApiResponse$1(status)
                        };
                }), CommonTypes_Invoice_Business.tToR(param.business));
  }
  
}

function compare$1(param, param$1) {
  return Curry._2(compare, param.id, param$1.id);
}

function eq$1(param, param$1) {
  return Curry._2(eq, param.id, param$1.id);
}

var $$Set = Relude_Set.WithOrd({
      eq: eq$1,
      compare: compare$1
    });

var Business;

var Flag;

var Shift;

var WorkerShift;

exports.Business = Business;
exports.Flag = Flag;
exports.Shift = Shift;
exports.WorkerShift = WorkerShift;
exports.Id = Id;
exports.InvoiceNumber = InvoiceNumber;
exports.ExternalInvoiceId = ExternalInvoiceId;
exports.ExternalInvoiceAmountCents = ExternalInvoiceAmountCents;
exports.Style = Style;
exports.Status = Status;
exports.Raw = Raw;
exports.query = query;
exports.parse = parse$4;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
exports.compare = compare$1;
exports.eq = eq$1;
exports.$$Set = $$Set;
/* include Not a pure module */
